var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalculationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 14H11M18.989 7C19 7.57703 19 8.23647 19 9C19 11.8003 19 13.2004 18.455 14.27C17.9757 15.2108 17.2108 15.9757 16.27 16.455C15.2004 17 13.8003 17 11 17H9C6.19974 17 4.79961 17 3.73005 16.455C2.78924 15.9757 2.02433 15.2108 1.54497 14.27C1 13.2004 1 11.8003 1 9C1 8.23647 1 7.57703 1.01105 7M18.989 7C18.9595 5.46078 18.8514 4.50797 18.455 3.73005C17.9757 2.78924 17.2108 2.02433 16.27 1.54497C15.2004 1 13.8003 1 11 1H9C6.19974 1 4.79961 1 3.73005 1.54497C2.78924 2.02433 2.02433 2.78924 1.54497 3.73005C1.14859 4.50797 1.04052 5.46078 1.01105 7M18.989 7H1.01105",
    stroke: "#77498F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculationIcon);
export default __webpack_public_path__ + "static/media/Calculation-Icon.fb0ad581f0908906cf23080c89cbb3ea.svg";
export { ForwardRef as ReactComponent };